import { FC } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import SwiperRaw from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'

import { ProgramContainer } from './program-container'
import { useLocale } from 'languages/use-locale'
import { SwiperContainer } from './styled'
import { FloatingShareButton } from './floating-share-button'

const Program: FC = () => {
  const local = useLocale()
  const params = useParams()
  const navigate = useNavigate()
  const currentProgramIndex = local.programs.findIndex(
    (p) => p.id.toString() === params.id
  )
  const currentProgram = local.programs[currentProgramIndex]

  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  const changeSlide = (swiper: SwiperRaw) => {
    const newProgram = local.programs[swiper.activeIndex]

    if (newProgram) {
      navigate(`/program/${newProgram.id}`)
    }
  }

  if (!currentProgram) {
    return null
  }

  return (
    <SwiperContainer>
      <Swiper
        draggable
        navigation
        autoHeight={true}
        breakpoints={{
          835: {
            autoHeight: false,
          },
        }}
        modules={[Navigation]}
        spaceBetween={20}
        key={currentProgramIndex}
        initialSlide={currentProgramIndex}
        noSwipingClass={'noSwipe'}
        onSlideChangeTransitionStart={scrollToTop}
        onSlideChangeTransitionEnd={changeSlide}
      >
        {local.programs.map((program) => {
          return (
            <SwiperSlide key={program.id}>
              <ProgramContainer program={program} />
            </SwiperSlide>
          )
        })}
      </Swiper>

      <FloatingShareButton currentProgram={currentProgram} />
    </SwiperContainer>
  )
}

export default Program
